import { apiClient } from './client';
import type { LoginRequest, LoginResponse, UserInfo, ChangePasswordRequest } from '@/types';

export const authApi = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const { data: response } = await apiClient.post<LoginResponse>('/api/v1/auth/login', data);
    return response;
  },

  logout: async (): Promise<void> => {
    try {
      await apiClient.post('/api/v1/auth/logout');
    } catch {
      // Ignorar errores de logout en cliente
    }
  },

  getProfile: async (): Promise<UserInfo> => {
    const { data } = await apiClient.get<UserInfo>('/api/v1/auth/me');
    return data;
  },

  changePassword: async (data: ChangePasswordRequest): Promise<void> => {
    await apiClient.post('/api/v1/auth/change-password', data);
  },

  refreshToken: async (): Promise<{ access_token: string; token_type: string }> => {
    const { data } = await apiClient.post('/api/v1/auth/refresh');
    return data;
  },
};
